<template>
    <section>
        <o-tabs type="toggle" v-model="activeTab" :animated="false">
            <o-tab-item :value="0" label="Wildlife Acoustics Files">
                <!-- this div is what used to be recording fields  -->
                <div class="block" >
                    <div class="form" >
                        <div class="field">
                            <label class="label">Recordings Name (4 character minimum)</label>
                            <div class="control">
                            <input
                                class="input"
                                :class="{'is-danger': errors.name}"
                                type="text"
                                v-model="name"
                                placeholder="Give a common name to the files">
                            </div>
                        </div>
                        <div class="field">
                            <p>Please note, device and date are now auto populated</p>
                        </div>
                    </div>
                </div>
            </o-tab-item>
            <o-tab-item :value="1" label="Other File Types">
                <!-- this div is what used to be recording fields  -->
                <div class="block" >
                    <div class="form" >
                        <div class="field">
                            <label class="label">Recordings Name (4 character minimum)</label>
                            <div class="control">
                            <input
                                class="input"
                                :class="{'is-danger': errors.name}"
                                type="text"
                                v-model="name"
                                placeholder="Give a common name to the files">
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Device ID (4 character minimum, no spaces)</label>
                            <div class="control">
                            <input
                                class="input"
                                :class="{'is-danger': errors.device}"
                                type="text"
                                v-model="device"
                                placeholder="The name of the recording device (no spaces)">
                            </div>
                        </div>
                        <div class="field">
                            <label class="label">Recording Date</label>
                            <div class="control">
                            <input
                                class="input"
                                :class="{'is-danger': errors.date}"
                                type="date"
                                v-model="date" >
                            </div>
                        </div>
                    </div>
                </div>
            </o-tab-item>
        </o-tabs>
    </section>
    
    <o-field>
        <o-switch v-model="dupeActive">Check for duplicates</o-switch>
    </o-field>
    <div class="block">
        <DropZone
        @choiceMade="choiceMade"
        :errors="errors"
        zoneTitle="Drag and Drop Files"/>
    </div>
    <div class="block">
        <span style="display: none;">
        this is a hidden element with the sole scope of re-render
        the list of colored files: {{count}}
        </span>
        <div class="p">{{helpfulMessage}}</div>
        <br>
        <div class="buttons is-fullwidth">
        <button class="button is-primary is-rounded" @click="upload" :disabled="checkingDuped">
            <span v-if="uploadActive || checkingDuped" class="icon"><i class="fas fa-sync fa-spin"></i></span>
            <span v-else class="icon"><i class="fas fa-upload"></i></span>
            <span>Upload</span>
        </button>
        </div>
        <div class="tags is-centered">
            <span v-for="file in files" >
                <span
                class="tag"
                :class="{
                    'is-info': file.uploading === 'started',
                    'is-success': file.uploading === 'completed',
                    'is-warning': file.duped,
                    'is-danger': file.wrongTab
                    }">
                {{ file.name }}
                <button class="delete is-small" @click="popFile(file)"></button>
                </span>
            </span>
        </div>
    </div>
    </template>


<script>
import { mapState, mapActions } from 'pinia'

import { getMD5, readBinaryFile, popItem } from '@/js/general.js'
import { useLogin  } from '@/js/auth.js'
import { getEtags } from '@/js/apis.js'
import { addFiles, addFile, s3encode } from '@/js/uploader.js'

import DropZone from '@/widgets/DropZone.vue'
import { watch } from 'vue'

var validFileTypes = [
    "audio/mid", "mid",
    "audio/mpeg", "mpeg",
    "audio/mp4", "mp4",
    "audio/ogg", "ogg",
    "audio/vorbis", "vorbis",
    "audio/wav", "audio/x-wav", "wav",
]

function filterAudio(files){
    return Array.from(files).filter(file => {
        if (validFileTypes.includes(file.type)) {
            return true
        } else {
            console.log(`file type is invalid... ${file.type} --- ${file.name}`)
            return false
        }
    })
}

function groupArr(data, n) {
    var group = [];
    for (var i = 0, j = 0; i < data.length; i++) {
        if (i >= n && i % n === 0)
            j++;
        group[j] = group[j] || [];
        group[j].push(data[i])
    }
    return group;
}

async function uploadFile(file, tags, path, callback){
    console.log("uploading......", file)
    file.uploading = "started"
    let resp = await addFile(file, tags, path)
    callback(undefined, {file: file, resp: resp})
    // file.uploading = "completed"
    file.uploading = "completed"
    // console.log("uploaded..........", file)
    return resp
}

async function uploadFilesParallel(files, tags, path, file_callback){
    let promises = []
    for (const file of Array.from(files)){
        let promise = uploadFile(file, tags, path, file_callback)
        promises.push(promise)
    }
    let results = []
    for (const promise of promises){
        let resp = await promise
        results.push(resp)
    }
    return resultsuploadFiles
}

async function uploadFiles(files, tags, path, file_callback){
    let results = []
    for (const file of Array.from(files)){
        if (file.recordingType === 'General') {
            tags.recordingType = file.recordingType
            console.log('Uploading General-type file')
        } else if (file.recordingType === 'Wildlife Acoustics') {
            tags = {...tags, soundDevice: '', soundDate: ''}
            if (file.device){
                tags.soundDevice = file.device
            } else {
                console.log("File name does not match Wildlife Acoustics standard")
            }
            if (file.date){
                tags.soundDate = file.date
            } else {
                console.log("File name does not match Wildlife Acoustics standard")
            }
            tags.recordingType = file.recordingType
            console.log('Uploading Wildlife Acoustics-type file')
        } else {
            console.log('file type is not supported')
        }
        let promise = uploadFile(file, tags, path, file_callback)
            let resp = await promise
            results.push(resp)
    }
    return results
}

async function uploadFilesWA(files, tags, path, file_callback){
let results = []
for (const file of Array.from(files)){
    tags = {...tags, soundDevice: '', soundDate: ''}

    if (file.device){
        tags.soundDevice = file.device
    } else {
        console.log("File name does not match Wildlife Acoustics standard")
    }

    if (file.date){
        tags.soundDate = file.date
    } else {
        console.log("File name does not match Wildlife Acoustics standard")
    }

    let promise = uploadFile(file, tags, path, file_callback)
    let resp = await promise
    results.push(resp)
}
return results
}

export default {
    name: 'UploadSound',
    components: { DropZone },
    emits: ["uploaded"],
    data(){
        return {
            name: '',
            device: '',
            date: '',
            files: [],
            errors: {},
            uploadActive: false,
            count: 0,
            dropped: 0,
            dupeActive: false,
            activeTab: 0,
        }
    },
    methods: {
        wrongTabChecker(files){
            for (const file of files){
                if (this.activeTab === 0 && file.recordingType === 'General') {
                    file.wrongTab = true
                } else if (this.activeTab === 1 && file.recordingType === 'Wildlife Acoustics'){
                    file.wrongTab = true
                }
            }
        },
        wrongTabErrorChecker(files){
            for (const file of files){
                if (file.wrongTab === true){
                    return true
                }
            }
        },
        clearFields(){
            this.name = '',
            this.device = '',
            this.date = '',
            this.files = [],
            this.errors = {},
            this.uploadActive =  false,
            this.count = 0,
            this.dropped = 0,
            this.dupeActive = false
        },
        popFile(file){
            this.files = popItem(file, this.files)
        },
        async choiceMade(event){
            var files = filterAudio(event.files)
            console.log(files)
            this.errors = {}
            this.files = []
            this.dropped = files.length
            for (const [index, ifile] of files.entries()) {
                this.checkFileType(ifile)
                if (this.dupeActive) {
                    let promise = readBinaryFile(ifile).then((data) => {
                        ifile.etag =  getMD5(data)
                    }).then(() => {
                        return getEtags(ifile.etag)
                    }).then((etag_response) => {
                        if (etag_response.length > 0){
                            ifile.duped = true
                        } else {
                            ifile.duped = false
                        }
                    }).then(() => {
                        this.files.push(ifile)
                    })
                    await promise
                    // console.log("done", ifile)
                } else {
                    ifile.duped = false
                    this.files.push(ifile)
                }
            }
            this.wrongTabChecker(files)
            this.errors = this.calculatedErrors
            this.dropped = 0
        },
        upload() {
            if (!this.valid){
                this.errors = this.calculatedErrors
                this.warn = true
            } else {
                this.warn = false
                this.uploadActive = true
                for (const ifile of this.files) {
                    // removing the 'is-warning' class from the file name tag...
                    ifile.duped = false
                }
                uploadFiles(
                    this.files,
                    this.tags,
                    `sounds/${this.email}/`,
                    (err, data) => {
                        console.log("merd")
                        setTimeout(() => {this.count = this.count + 1}, 50)
                    }
                ).then((err, resp) => {
                    console.log("UploadSound.upload upload complete...")
                    setTimeout(() => {
                    // this timeout is a bit crappy
                    // just giving S3 enough time to sort itself out
                        this.uploadActive = false;
                        this.$emit("uploaded", {file: this.files})
                    }, 500)
                })
            }
        },
        checkFileType(file) {
            const regex = /^([a-zA-Z0-9]+)_(\d{8})_(\d{6})\.wav$/
            const match = file.name.match(regex)
            if (match) {
                file.recordingType = 'Wildlife Acoustics'
                console.log('file type is Wildlife Acoustics')
                file.device = match[1]
                console.log("Device Name:", file.device)

                const dateString = match[2]
                const year = dateString.slice(0, 4)
                const month = dateString.slice(4, 6)
                const day = dateString.slice(6, 8)

                const timeString = match[3]
                const hours = timeString.slice(0, 2)
                const minutes = timeString.slice(2, 4)
                const seconds = timeString.slice(4, 6)

                const dateObj = new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`)
                file.date = dateObj.toISOString()
                console.log("Date (formatted): ", file.date)

            } else {
                file.recordingType = 'General'
                console.log("File type is general")
            }
        },
    },
    computed: {
        ...mapState(useLogin, ["email"]),
        checkingDuped(){
            return this.dropped > 0
        },
        helpfulMessage(){
            // if (this.dropped === 0 || this.files.length === 0)
            if (this.checkingDuped){
                return `Cheking for duplicated files; ${this.files.length} checked of ${this.dropped}`
            } else if (this.files.length > 0 && !this.uploadActive) {
                if (this.valid){
                    return `Ready to upload ${this.files.length} files...`
                } else if (!this.valid && this.errors.wrongTab === true && this.activeTab === 0){
                    return 'Please remove non Wildlife Acoustics files before uploading'
                } else if(!this.valid && this.errors.wrongTab === true && this.activeTab === 1){
                    return 'Please remove Wildlife Acoustics files before uploading, or use the Wildlife Acoustics uploader'
                }else{
                    return `complete the form to start the upload...`
                }
            } else if (this.uploadActive) {
                return `uploading ${this.files.length} files...`
            }
            return ""
        },
        tags() {
            return {
                soundDevice: s3encode(this.device),
                soundName: s3encode(this.name),
                soundHref: s3encode(window.location.href),
                soundDate: this.date,
                soundUser: this.email,
                soundSource: "portal",
            }
        },
        valid() {
            let checker = arr => arr.every(v => ! v === true);
            return checker(Object.values(this.calculatedErrors))
        },
        calculatedErrors() {
            let errors = {}
            if (this.name.length < 4){
                console.log("UploadSound.fieldsValidate: recording name too short...")
                errors.name = true
            }
            if (this.device.length < 4 && this.activeTab === 1){
                console.log("UploadSound.fieldsValidate:device id too short...")
                errors.device = true
            }
            if (this.files.length < 1){
                console.log("UploadSound.fieldsValidate:no files...")
                errors.files = true
            }
            if (this.wrongTabErrorChecker(this.files) === true){
                console.log('UploadSound.wrong tab error')
                errors.wrongTab = true
            }
            return errors
        },
        uploadAllowed(){
            return !this.uploadActive && this.valid
        },
    },
    watch: {
        activeTab(){
            this.clearFields()
        }
    }
}
</script>
